import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";

import { ADD_USER_REQUEST } from "./UserTypes";
import { addUserFailure, addUserSuccess } from "./UserAction";
import axiosInstance from "../instance/AxiosInstance";

function* addUserSaga(action) {
  try {
    const response = yield call(
      axiosInstance.post,
      `/auth/register`,
      action.payload
    );

    yield put(addUserSuccess(response.data.data));
  } catch (error) {
    const errorDetails = error.response?.data || {};
    const errorFields = errorDetails.errorFields || {};
    const additionalErrors = errorDetails.additionalErrors || {};
    const message = errorDetails.message || "Failed to add user";
    yield put(
      addUserFailure({
        message,
        additionalErrors,
        errorFields,
      })
    );
  }
}

export default function* userSaga() {
  yield takeLatest(ADD_USER_REQUEST, addUserSaga);
}
